import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthCommonService } from "../shared/Authentication/auth.service";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
 
 
@Injectable({
    providedIn: 'root'
})
 
export class FuzzyMatchService {
    apiURL = environment._fuzzyMatchApiBaseURL;
 
    constructor(private http:HttpClient, private authCommonService: AuthCommonService)
    {
    }
 
    public getFuzzyMatchResults(files: FormData): Observable<any> {
        const headers = new HttpHeaders({
            'ApiKey': this.authCommonService.getAuthenticationToken()
        });
 
        if (!this.apiURL) {
        throw new Error('API URL is not defined');
        }

        return this.http.post<any>(
             //'https://devapi.freyrkontractpro.com/api/v1/productwisecosting/MatchProducts', // for Dev Environment
            //  this.apiURL + '/match-products',
             //  'http://localhost:9000/api/v1/MatchProducts', // For Local Environment
               this.apiURL,
               files,
              { headers }
            );

       
    }
 
}
 